import { render, staticRenderFns } from "./MaterialLocationTable.vue?vue&type=template&id=3d82d7b6&scoped=true"
import script from "./MaterialLocationTable.vue?vue&type=script&lang=js"
export * from "./MaterialLocationTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d82d7b6",
  null
  
)

export default component.exports